import { getRgObjectsOfType as t, RgChildren as i } from "@project-rouge/rg-core";
import { isBaseBuildObject as l } from "../../queries/index2.js";
import { getVerticalWallArea as o } from "./index59.js";
const m = (e) => {
  const r = t(e, i.Building).filter(l);
  return o(r);
};
export {
  m as getBaseBuildWallArea
};
//# sourceMappingURL=index9.js.map
